import { render, staticRenderFns } from "./modelZT.vue?vue&type=template&id=21640b64"
import script from "./modelZT.vue?vue&type=script&lang=js"
export * from "./modelZT.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports